import { gql } from '@apollo/client';

export const DECODE_VIN_VALUES = gql`
  query DecodeVinValues($vin: String!) {
    decodeVinValues(vin: $vin)
  }
`;
